import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
const useSwitchLanguage = () => {
  const $ = _c(2);
  const {
    i18n
  } = useTranslation();
  let t0;
  if ($[0] !== i18n) {
    t0 = language => {
      i18n.changeLanguage(language);
      document.documentElement.setAttribute("lang", language);
      const url = new URL(window.location.href);
      url.searchParams.set("lng", language);
      window.history.replaceState(window.history.state, "", url);
    };
    $[0] = i18n;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default useSwitchLanguage;